<template>
  <div>
    <!-- <CCol xs="12" md="12" lg="6" class="col-centered update-column">
      <h4 class="card-title">Mass Notification</h4>
      <h6 class="card-subtitle"><a href="#">Back to list</a></h6>
      <hr>
      <div style="clear:both"></div>
      <div><label><strong>Group Name</strong> </label></div>
      <textarea class="form-control"> </textarea>
      <br>
      <div><label><strong>Description</strong></label></div>
      <textarea class="form-control" rows="5"> </textarea>
      <br>
      <div><label><strong>User List</strong></label></div>
      <input class="form-control">
      <br>
      <input type="submit" value="Save Group" class="btn btn-success" />
      <br>
    </CCol>
    <br>      
    
    
    <CCol xs="12" md="12" lg="6" class="col-centered update-column">
      <h4 class="card-title">Send Group Mass Notification</h4>
      <h6 class="card-subtitle"><a href="#">Back to list</a></h6>
      <hr>
      <div style="clear:both"></div>
      <div><label><strong>Notification Title</strong> </label></div>
      <textarea class="form-control" rows="2"> </textarea>
      <br>
      <div><label><strong>Description</strong></label></div>
      <textarea class="form-control" rows="2"> </textarea>
      <br>
      <div><label><strong>User List</strong></label></div>
      <input class="form-control">
      <br>
      <input type="submit" value="Send Mass Notification" class="btn btn-success" />
      <br>
    </CCol>
    <br>      


    <CCol xs="12" md="12" lg="12" class="col-centered update-column">
      <h4 class="card-title">Send Group Mass Notification</h4>
      <h6 class="card-subtitle"><a href="#">Back to list</a></h6>
      <hr>
      <div style="clear:both"></div>
      <input type="submit" value="Add Group" class="btn btn-success" />
      <CCol sm="12">
        <CDataTable
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="list"
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          :dark="dark"
          clickable-rows
          pagination
          hover
        >
          <template #GroupName="{ item }">
            <td>
              <h6 style="color: #1e109c" class="text-uppercase">
                {{ item.gname }}
              </h6>                
            </td>
          </template>

          <template #Description="{ item }">
            <td>
              {{ item.desc }}
            </td>
          </template>

          <template #Action ="{ item }">
            <td>
              <CDropdown toggler-text="Action" class="m-2 btn-act" color="primary">
                <CDropdownItem @click="people(item)">
                  List of People
                </CDropdownItem>
                <CDropdownItem @click="payment(item)">
                  Add Additional Payment
                </CDropdownItem>
                <CDropdownItem @click="dlete(item)">
                  Delete Group
                </CDropdownItem>
              </CDropdown>
            </td>
          </template>
        </CDataTable>
      </CCol>
      <br>
    </CCol>
    <br>  -->
    
    

     <div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
   <CCol sm="12">
      <CRow>
        <CCol sm="4">
         <CInput
                type="text"
                placeholder="Search text"
                v-model.lazy="SearchQuery"
                @change="ApplyFilter()"
              />
        </CCol>

      </CRow>

       <CRow>
        <!-- <CCol sm="3">
          <v-select
            v-model="selectedName"
            :options="nameOptions"
            label="Name"
            class="custom-btn-blue style-chooser"
            @input="FilteredData()"
          ></v-select>
        </CCol>

         <CCol sm="3">
          <v-select
            v-model="selectedView"
            :options="viewOptions"
            label="IsSeen"
            class="custom-btn-blue style-chooser"
            @input="FilteredData()"
          ></v-select>
        </CCol>

        <CCol sm="3"> </CCol>

          <CCol sm="3">
            <CButton
              class="custom-btn-success"
              type="button"
              @click="OpenFormBroadcast()"
              ><CIcon name="cil-plus" />Add Broadcast</CButton
            >
          </CCol> -->
      </CRow>
    </CCol>
      <CCol sm="12">

        <CRow>
            <CCol sm="6">
            <div>
              <CButton
                class="btn-success"
                type="button"
                @click="OpenFormMassGroup()"
                ><CIcon name="cil-plus" />Create Group</CButton
              >
              <!-- <CButton
                class="btn-primary ml-2"
                type="button"
                >Send Mass</CButton
              > -->
              <CButton
                class="btn-info ml-2"
                type="button"
                @click="GoToList()"
                >Group List</CButton
              >
            </div>
          </CCol>
        </CRow>
      </CCol>
      <CCol sm="12">
        <CDataTable
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="FilteredNoti"
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          :dark="dark"
          clickable-rows
          sorter
          pagination
        >
          <template #GroupName="{ item }">
            <td>
              <h6 style="color: #1e109c" class="text-uppercase">
                {{ item.GroupName }}
              </h6>
            </td>
          </template>

          <template #Name="{ item }">
            <td>
              {{ item.Name }}
            </td>
          </template>

          <template #Email="{ item }">
            <td>
              {{ item.Email }}
            </td>
          </template>
            <template #Title="{ item }">
            <td>
              {{ item.Title }}
            </td>
          </template>
            <template #Description="{ item }">
            <td>
              {{ item.Description }}
            </td>
          </template>
           <template #CreatedTime="{ item }">
            <td>
              {{ item.CreatedTime }}
            </td>
          </template>

          <template #IsSeen="{ item }">
            <td>
              <CBadge v-if="item.IsSeen === true" color="success"
                >Viewed</CBadge
              >
              <CBadge v-else color="danger">Not Viewed</CBadge>
            </td>
          </template>
        </CDataTable>
      </CCol>


      <CModal title="Add Group" size="lg" :show.sync="MassModal">
        <div>
          <h6><strong>FORM GROUP</strong></h6>
          <br />
          <CCol sm="12">
            <CRow>
              <CCol sm="3"> Group Name </CCol>
              <CCol sm="9"> <CInput type="text" v-model="GroupName" /> </CCol>
              <CCol sm="3"> Description </CCol>
              <CCol sm="9"> <CInput type="text" v-model="Description" /> </CCol>
              <div style="clear: both"></div>
              <hr />

              <CCol sm="12">
                <CRow>
                  <CCol sm="4">
                    <CInput
                      type="text"
                      placeholder="Search text"
                      v-model.lazy="SearchQueryModal"
                      @change="ApplyFilterModal()"
                    />
                  </CCol>
                </CRow>
              </CCol>

              <CCol sm="12">
                <CDataTable
                  :bordered="bordered"
                  :small="small"
                  :fixed="fixed"
                  :items="FilteredUserList"
                  :fields="fieldUserList"
                  items-per-page-select
                  :items-per-page="small ? 5 : 10"
                  :dark="dark"
                  clickable-rows
                  sorter
                  pagination
                  :selected="selectedItems"
                >

                  <template #Check="{ item }">
                    <td>
                      <input type="checkbox" :value="item" @click="checkAll()" v-model="isCheckAll" />
                    </td>
                  </template>

                  <template #Name="{ item }">
                    <td>
                      <h6 style="color: #1e109c" class="text-uppercase">
                        {{ item.Name }}
                      </h6>
                    </td>
                  </template>

                  <template #ParentEmail="{ item }">
                    <td>
                      {{ item.ParentEmail }}
                    </td>
                  </template>

                  <template #UserType="{ item }">
                    <td>
                      {{ item.UserType }}
                    </td>
                  </template>
                    <template #TuitionCenter="{ item }">
                    <td>
                      {{ item.TuitionCenter }}
                    </td>
                  </template>
                    
                </CDataTable>

                
              </CCol>
            </CRow>
          </CCol>
        </div>

        <template #footer>
          <CButton type="submit" class="p-2" color="info" @click="InsertGroupMass()"> Proceed </CButton>
        </template>
      </CModal>
    </div>
  </div>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    VCalendar,
    VueCal,
  },
  data() {
    return {
      noti: [],
      FilteredNoti: [],
      SearchQuery: "",
      SearchQueryModal: "",

      perPage: 10,
      pagination: {},
      currentPage: 1,

      selectedName: "ALL TEACHER",
      nameOptions: [],

      selectedView: "ALL VIEW",
      viewOptions: [],

      Busy: false,

      fields: [
        { key: "GroupName" },
        { key: "Name" },
        { key: "Email" },
        { key: "Title" },
         { key: "Description" },
          { key: "CreatedTime" },
           { key: "IsSeen" },
      ],
       fieldUserList: [
         { key: "Check" },
        { key: "Name" },
        { key: "ParentEmail" },
        { key: "UserType" },
        { key: "TuitionCenter" },
      ],
      FilteredUserList: [],
      users: [],
      MassModal: false,

        isCheckAll: false,
        GroupName: "",
        Description: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetNoti();
    } else {
      this.GoToLogin();
    }
  },

  async mounted() {
    this.GetNoti();
  },
  methods: {
    GetNoti() {
      this.Busy = true;
      this.$API
        .get(this.$GetMassNotification, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.noti = response.data;
            this.FilteredNoti = this.noti;

          }
        });
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.noti, ["Description"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ Description }) =>
          _.some([
            _.includes(!Description || Description.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilteredNoti = result;
      }
    },

    

    FilteredData() {
      console.log("masuk");
      this.FilteredNoti = this.noti;

      if (this.selectedName !== "ALL PARENT")
        this.FilteredNoti = _.filter(
          this.FilteredNoti,
          (item) => item.Name === this.selectedName
        );

      if (this.selectedView !== "ALL VIEW")
        this.FilteredNoti = _.filter(
          this.FilteredNoti,
          (item) => item.IsSeen === this.selectedView
        );

      // if (this.selectedTeacher !== "ALL TEACHER")
      //   this.FilteredAttendance = _.filter(
      //     this.FilteredAttendance,
      //     (item) => item.Teacher === this.selectedTeacher
      //   );
    },
     OpenFormMassGroup() {

       this.$API
        .get(this.$ViewStudent, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.users = response.data;
            this.FilteredUserList = this.users;
          }
        });
     
      this.MassModal = true;
    },

    ApplyFilterModal: function () {
      var arr = _.orderBy(this.users, ["Name"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ Name }) =>
          _.some([
            _.includes(!Name || Name.toLowerCase(), [
              this.SearchQueryModal.toLowerCase(),
            ]),
          ])
        );
        this.FilteredUserList = result;
      }
    },

      checkAll: function () {
      this.isCheckAll = !this.isCheckAll;
      var temp = this;
      this.users.forEach(function (item) {
        if (item.isChecked !== temp.isCheckAll) {

          item.isChecked = temp.isCheckAll;
        }
      });
    },
      InsertGroupMass() {
      const formData = new FormData();
      var count = 0;
      for (var index = 0; index < this.users.length; index++) {
        var pv = this.users[index];
        if (pv.isChecked) {
          formData.append("userList[" + count + "]", pv.Id);
          count++;
        }
      }
      formData.append("GroupName", this.GroupName);
       formData.append("Description", this.Description);

      return this.$API
        .post(this.$InsertMassGroup, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.MassModal = false;
            this.$dialog
              .alert("You have successfully create group")
              .then(function () {});
            this.isCheckAll = false;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    GoToList()
    {
      this.$router.push("/TuitionMassNotificationList");
    }

  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
.custom-btn-success {
  color: #fff;
  background-color: #2eb85c;
  border-color: #2eb85c;
  width: 230px;
}
.style-chooser .vs__open-indicator {
  fill: rgb(251 248 254);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms
    cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
    -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
  fill: rgb(251 248 254);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #009efb;
  border-radius: 4px;
  white-space: normal;
  height: 36px;
}
.style-chooser .vs__selected {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #009efb;
  border: 1px solid #009efb;
  border-radius: 4px;
  color: #fff;
  line-height: 1.4;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
  z-index: 0;
}
.style-chooser .vs__single .vs__selected {
  background-color: #009efb;
  border-color: #009efb;
}
.custom-btn-blue {
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
}
</style>



